import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { TestesModel, TypeToAvaliacaoModel } from '../../../../domain/models'
import { fetchTest, fetchTypeToService } from '../../../../main/usecases'

import { goToUrl } from '../../../utils'
import { useModalBox } from '../../../contexts'
import { Button, SelectInput } from '../../../components'

import * as S from './styles'

export type TestesDataProps = {
  typeToService: number
  cdTeste: number
}

const FilterCustomTesteModal = () => {
  const [loading, setLoading] = useState(false)
  const [typeToTeste, setTypeToTeste] = useState<TestesModel[]>()
  const [typeToService, setTypeToService] = useState<TypeToAvaliacaoModel[]>()
  const [documentsData, setDocumentsData] = useState<TestesDataProps>(
    {} as TestesDataProps
  )
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const history = useHistory()

  const optionsListTestes = useMemo(
    () =>
      typeToTeste?.map((item) => {
        return {
          value: item?.cdTeste,
          label: item?.nome
        }
      }),
    [typeToTeste]
  )

  const optionsListServices = useMemo(
    () =>
      typeToService?.map((item) => {
        return { value: item?.cdTipoAvaliacao, label: item?.tipoAvaliacao }
      }),
    [typeToService]
  )

  const handleFilterCustomDocument = async (
    teste?: TestesModel,
    typeToService?: TypeToAvaliacaoModel
  ) => {
    try {
      setLoading(true)
      goToUrl(history, `/teste`, {
        cdTeste: teste && teste.cdTeste,
        cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
        testTitle: teste && teste.nome,
        serviceTitle: typeToService && typeToService.tipoAvaliacao
      })

      modalClose(true)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar o teste personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const dataToTypeToDocuments = await fetchTest().load()
        const dataToTypeToServices = await fetchTypeToService().load()
        setTypeToTeste(dataToTypeToDocuments)
        setTypeToService(dataToTypeToServices)
        setDocumentsData({
          cdTeste: dataToTypeToDocuments[0].cdTeste,
          typeToService: dataToTypeToServices[0].cdTipoAvaliacao
        })
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  return (
    <S.ModalInfo>
      <SelectInput
        labelColor="#4F4F4F"
        label="Teste*"
        name="cdTeste"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            cdTeste: Number(e.target.value)
          }))
        }
        value={documentsData?.cdTeste}
        options={optionsListTestes}
      />
      <SelectInput
        labelColor="#4F4F4F"
        label="Tipo do avaliação*"
        name="typeToService"
        onChange={(e: any) =>
          setDocumentsData((prev: any) => ({
            ...prev,
            typeToService: Number(e.target.value)
          }))
        }
        value={documentsData?.typeToService}
        options={optionsListServices}
      />
      <Button
        disabled={loading}
        onClick={() =>
          handleFilterCustomDocument(
            typeToTeste?.find((item) => item.cdTeste === documentsData.cdTeste),
            typeToService?.find(
              (item) => item.cdTipoAvaliacao === documentsData.typeToService
            )
          )
        }
      >
        Filtrar
      </Button>
    </S.ModalInfo>
  )
}

export default FilterCustomTesteModal
